import gql from 'graphql-tag';

export class FormInput {
  id: number;
  name: string;
  collectorId: number;
  seriestypeId: number;
  docPrefix: string;
  startNumber: number;
  endNumber: number;
  isYearlyRenumbering: boolean;
  leadingZeros: boolean;
  isActive: boolean;
  firstDate: Date;
  lastDate: Date;
  firstUser: string;
  lastUser: string;

  constructor() {
    this.id = undefined;
    this.name = undefined;
    this.collectorId = undefined;
    this.seriestypeId = undefined;
    this.docPrefix = undefined;
    this.startNumber = undefined;
    this.endNumber = undefined;
    this.isYearlyRenumbering = undefined;
    this.leadingZeros = undefined;
    this.isActive = undefined;
    this.firstDate = undefined;
    this.lastDate = undefined;
    this.firstUser = undefined;
    this.lastUser = undefined;
  }
}

export const gqlGetQuery = gql`
  query getEdocSeries($limit: Int, $offset: Int, $order: String, $where: String) {
    getEdocSeries(limit: $limit, offset: $offset, order: $order, where: $where) {
      data {
        id
        name
        collectorId
        seriestypeId
        docPrefix
        startNumber
        endNumber
        isYearlyRenumbering
        leadingZeros
        collector {
          id
          name
        }
        edocSeriesType {
          id
          value
          name
        }
        isActive
        firstDate
        lastDate
        firstUser
        lastUser
        edocSeriesNumbers {
          id
          year
          lastNumber
          lastCode
        }
      }
      recordCount
    }
  }
`;

export const gqlGetByIdQuery = gql`
  query getEdocSeriesById($id: Int) {
    getEdocSeriesById(id: $id) {
      id
      name
      collectorId
      seriestypeId
      docPrefix
      startNumber
      endNumber
      isYearlyRenumbering
      leadingZeros
      isActive
      firstDate
      lastDate
      firstUser
      lastUser
      edocSeriesNumbers {
        id
        year
        lastNumber
        lastCode
      }
      edocSeriesType {
        id
        value
        name
      }
    }
  }
`;

export const gqlAdd = gql`
  mutation addEdocSeries($data: EdocSeriesInput) {
    addEdocSeries(data: $data) {
      id
      name
    }
  }
`;

export const gqlUpdate = gql`
  mutation updateEdocSeries($data: EdocSeriesInput) {
    updateEdocSeries(data: $data) {
      id
      name
    }
  }
`;

export const gqlDelete = gql`
  mutation deleteEdocSeries($id: Int) {
    deleteEdocSeries(id: $id)
  }
`;

export const gqlInitEdocSeries = gql`
  mutation initEdocSeries($collectorId: Int) {
    initEdocSeries(collectorId: $collectorId)
  }
`;
